'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ID = exports.ID = ['id'];
var OBJECT_TYPE = exports.OBJECT_TYPE = ['objectType'];
var OBJECT_ID = exports.OBJECT_ID = ['objectId'];
var OBJECT_NAME = exports.OBJECT_NAME = ['objectName'];
var UPDATE = exports.UPDATE = ['crmObjectUpdate'];
var TIMESTAMP = exports.TIMESTAMP = ['timestamp'];
var SOURCE = exports.SOURCE = ['source'];
var SOURCE_ID = exports.SOURCE_ID = ['sourceId'];

var UPDATE_TYPE = exports.UPDATE_TYPE = ['@type'];
var PIPELINE_ID = exports.PIPELINE_ID = ['pipelineId'];
var PIPELINE_NAME = exports.PIPELINE_NAME = ['pipelineName'];
var PIPELINE_STAGE_ID = exports.PIPELINE_STAGE_ID = ['pipelineStageId'];
var PIPELINE_STAGE = exports.PIPELINE_STAGE = ['pipelineStage'];

var CRM_CREATION_SOURCE = exports.CRM_CREATION_SOURCE = ['crmObjectUpdate', 'crmCreationSource'];
var FORM_NAME = exports.FORM_NAME = ['crmObjectUpdate', 'crmCreationSource', 'name'];
var FORM_ID = exports.FORM_ID = ['crmObjectUpdate', 'crmCreationSource', 'connectedObjectSourceId'];